import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "panel",
    "query",
    "searchButton",
    "reset",
    "apply",
    "enhancement",
    "activity",
    "picker",
    "addButton",
  ];

  connect() {
    this.caching = false;
    if (this.hasQueryTarget) this.searchedQuery = this.queryTarget.value.trim();
    if (this.hasSearchButtonTarget) this.searchButtonTarget.hidden = true;
    this.enhancementTargets.forEach((element) => {
      element.hidden = false;
    });
    this.syncActivity();
  }

  submit(event) {
    if (this.hasApplyTarget && event.submitter === this.applyTarget) return;
    if (this.hasPanelTarget && this.panelTarget.open) event.preventDefault();
    else if (this.hasQueryTarget) this.searchedQuery = this.queryTarget.value.trim();
  }

  searchChanged() {
    if (!this.hasResetTarget) return;
    const url = new URL(this.resetTarget.href);
    if (this.queryTarget.value.trim()) url.searchParams.set("q", this.queryTarget.value.trim());
    else url.searchParams.delete("q");
    this.resetTarget.href = url.toString();
  }

  toggled() {
    if (this.panelTarget.open || this.caching) return;
    this.restore();
    if (this.hasQueryTarget && this.queryTarget.value.trim() !== this.searchedQuery)
      this.element.requestSubmit(this.searchButtonTarget);
  }

  restore() {
    const query = this.hasQueryTarget ? this.queryTarget.value : null;
    this.element.reset();
    if (this.hasQueryTarget) this.queryTarget.value = query;
    this.syncActivity();
  }

  beforeCache() {
    if (!this.hasPanelTarget) return;
    this.caching = true;
    this.panelTarget.open = false;
    this.restore();
  }

  cancel(event) {
    if (!this.hasPanelTarget || !this.panelTarget.open) return;
    event.preventDefault();
    this.panelTarget.open = false;
    this.panelTarget.querySelector("summary").focus();
  }

  addActivity({ currentTarget }) {
    const row = this.activityTargets.find((element) => element.dataset.metric === currentTarget.dataset.metric);
    row.hidden = false;
    this.pickerTarget.open = false;
    this.syncPicker();
    row.querySelector("input:checked").focus();
  }

  removeActivity({ currentTarget }) {
    const row = currentTarget.closest("[data-metric]");
    row.querySelector('input[value=""]').checked = true;
    row.hidden = true;
    this.syncPicker();
    this.pickerTarget.querySelector("summary").focus();
  }

  syncActivity() {
    this.activityTargets.forEach((row) => {
      row.hidden = !row.querySelector('input:checked:not([value=""])');
    });
    this.syncPicker();
  }

  syncPicker() {
    this.addButtonTargets.forEach((button) => {
      button.hidden = this.activityTargets.some((row) => row.dataset.metric === button.dataset.metric && !row.hidden);
    });
    if (this.hasPickerTarget) this.pickerTarget.hidden = this.addButtonTargets.every((button) => button.hidden);
  }
}
